import { combineReducers } from 'redux';
import authReducer from './authReducer';
import errorReducer from './errorReducer';
import reservationReducer from './reservationReducer';
import userReducer from './userReducer';
import cartReducer from './cartReducer';
import productReducer from './productReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  error: errorReducer,
  reservation: reservationReducer,
  user: userReducer,
  cart: cartReducer,
  product: productReducer,
});
export default rootReducer;
